// extracted by mini-css-extract-plugin
export default {"faq":"Pricing_faq__96fBb","pricing":"Pricing_pricing__jlI-c"};